import BaseModelAPI from '../BaseModelAPI';

export default class Jig extends BaseModelAPI {
	static entity = 'jig';
	static entityName = 'jig';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.jigLong = '';
			this.height = '';
			this.remark = '';
			this.wide = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}